/**
 *
 * @param {string} data - 要加密的数据
 * @param {string} publicKeyPem - PEM格式的公钥字符串
 * @returns {string} - Base64编码的加密数据
 */
export function rsaEncrypt(data, publicKeyPem) {
  // 创建 JSEncrypt 实例
  const encrypt = new JSEncrypt({
    default_key_size: 2048,
    default_public_exponent: '010001',
  });

  // 设置公钥
  encrypt.setPublicKey(publicKeyPem);

  // 使用公钥加密数据，并返回Base64编码的加密结果
  const encryptedData = encrypt.encrypt(data);

  if (encryptedData === false) {
    throw new Error('Encryption failed');
  }

  return encryptedData;
}

export const pubKey =  `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjU/O+G/DOc+zp/8Z3vqPJW6k8pn14XekPFnLClPMD75KUB81qFkN0lKDZo+fEkkhRjwIR5/tg/creY4ptqHT5GPChlytL99jNPXBazEvTSL+YI5waYbca6Hg6V1I3dRc0w4FJsiTSEbZzmt9gKLAJGYjTvsw3Y2Js6b0nBtE2zuHgdtz4Z2q7mYJj/IuWIpMvzC5XsP+/m5jbUjpcVYR1Cl2CdLPOWVbgTXeWrBpF2tWW66nPdN3S9P0c1oRzDwpt5zEbmZ/Ff46ABR6XQMAFF/bXFHCT2rnICqB5zHZrWg5yeh327xgOjoB3js3GMmaSN5ijYK1r99nPYctF+RkVwIDAQAB
-----END PUBLIC KEY-----`;